module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/nc-046cebb8a66efa64641c9c90e9f077b2.svg";